<div class="accessibility-page">
  <div class="accessibility-card">
    <div class="accessibility-header">
      <p class="eyebrow">Accessibilità</p>
      <h1>
        @if (lang() === 'it') {
          Modello di dichiarazione di accessibilità del sito web
        } @else {
          Website Accessibility Declaration Template
        }
      </h1>
      <p class="updated-at">
        @if (lang() === 'it') {
          Ultimo aggiornamento: 22/05/2026
        } @else {
          Last updated: 05/22/2026
        }
      </p>
    </div>

    <div class="lang-toggle" role="group" aria-label="Selezione lingua / Language selection">
      <button
        type="button"
        [class.active]="lang() === 'it'"
        (click)="setLang('it')"
        lang="it"
        [attr.aria-pressed]="lang() === 'it'"
      >Italiano</button>
      <button
        type="button"
        [class.active]="lang() === 'en'"
        (click)="setLang('en')"
        lang="en"
        [attr.aria-pressed]="lang() === 'en'"
      >English</button>
    </div>

    @if (lang() === 'it') {
      <article lang="it" class="declaration-content">

        <p class="legal-ref">
          D.lgs 10 agosto 2018, n. 106 — Direttiva UE 2016/2102 del Parlamento europeo e del Consiglio
        </p>

        <section aria-labelledby="heading-dichiarazione">
          <h2 id="heading-dichiarazione">Dichiarazione di accessibilità</h2>
          <p>
            Il soggetto erogatore si impegna a rendere le proprie piattaforme digitali accessibili,
            conformemente al D.lgs 10 agosto 2018, n. 106 che ha recepito la direttiva UE 2016/2102
            del Parlamento europeo e del Consiglio.
          </p>
          <p>
            La presente dichiarazione di accessibilità si applica al sito
            <a href="https://paleasy.axa.it" target="_blank" rel="noopener noreferrer">https://paleasy.axa.it</a>.
          </p>
        </section>

        <section aria-labelledby="heading-conformita">
        <h2 id="heading-conformita">Stato di conformità</h2>
        <p>
          Questo sito è <strong>totalmente conforme</strong> ai requisiti previsti dall'allegato A
          alla norma UNI EN 301549:2018 (WCAG 2.1) e ai requisiti ex allegato A DM 5 luglio 2005
          (WCAG 2.0).
        </p>
        </section>

        <section aria-labelledby="heading-redazione">
        <h2 id="heading-redazione">Redazione della dichiarazione di accessibilità</h2>
        <p>
          La presente dichiarazione è stata redatta il <time datetime="2026-03-17">17/03/2026</time>
          e aggiornata in data <time datetime="2026-05-22">22/05/2026</time> sulla base di valutazione
          e assessment effettuata da terzi.
        </p>
        </section>

        <section aria-labelledby="heading-feedback">
        <h2 id="heading-feedback">Feedback e informazioni di contatto</h2>
        <p>
          Le persone che necessitano di tecnologie assistive o di configurazioni particolari nella
          navigazione dei contenuti possono richiedere assistenza in merito all'accessibilità e
          lasciare eventuali feedback all'indirizzo e-mail
          <a href="mailto:insurancedigitalhub-support@deloitte.it">insurancedigitalhub-support&#64;deloitte.it</a>.
        </p>
        <p>Occorre riportare nel testo della mail, oltre alla segnalazione, le seguenti informazioni:</p>
        <ul>
          <li>URL del sito, della pagina o del documento e spiegazione della segnalazione</li>
          <li>
            Strumenti in dotazione (sistema operativo, browser ed eventuali strumenti compensativi
            e tecnologie assistive in dotazione)
          </li>
        </ul>
        <p>
          La risposta ad eventuali domande e segnalazioni avverrà entro 30 giorni dalla ricezione.
          Eventuali segnalazioni fuori dall'ambito accessibilità non potranno essere gestite.
        </p>
        <p>Il trattamento dati personali avverrà come da informativa privacy.</p>
        </section>

        <section aria-labelledby="heading-agid">
        <h2 id="heading-agid">Modalità di invio delle segnalazioni all'AgID</h2>
        <p>
          In caso di risposta insoddisfacente o di mancata risposta, nel termine di trenta giorni,
          alla notifica o alla richiesta, la persona interessata può inoltrare una segnalazione
          utilizzando la modalità indicata nel sito istituzionale di AgID.
        </p>
        </section>

        <section aria-labelledby="heading-info-sito">
        <h2 id="heading-info-sito">Informazioni sul Sito Web</h2>
        <dl>
          <dt>Data di pubblicazione del sito</dt>
          <dd><time datetime="2026-05-31">31/05/2026</time></dd>

          <dt>Sono stati effettuati test di usabilità?</dt>
          <dd>Sì</dd>

          <dt>CMS utilizzato per il sito web</dt>
          <dd>Nessun CMS (Web-Application Custom)</dd>
        </dl>
        </section>

        <section aria-labelledby="heading-struttura">
        <h2 id="heading-struttura">Informazioni sulla Struttura</h2>
        <dl>
          <dt>Numero di dipendenti con disabilità presenti nell'amministrazione</dt>
          <dd>0</dd>

          <dt>Numero di postazioni di lavoro per dipendenti con disabilità</dt>
          <dd>0</dd>
        </dl>
        </section>

      </article>
    }

    @if (lang() === 'en') {
      <article lang="en" class="declaration-content">

        <p class="legal-ref">
          Legislative Decree of August 10, 2018, No. 106 — EU Directive 2016/2102 of the European
          Parliament and the Council
        </p>

        <section aria-labelledby="heading-statement">
        <h2 id="heading-statement">Accessibility Statement</h2>
        <p>
          The provider is committed to making its website accessible in accordance with Legislative
          Decree of August 10, 2018, No. 106, which incorporates EU Directive 2016/2102 of the
          European Parliament and the Council.
        </p>
        <p>
          This accessibility statement applies to the website
          <a href="https://paleasy.axa.it" target="_blank" rel="noopener noreferrer">https://paleasy.axa.it</a>.
        </p>
        </section>

        <section aria-labelledby="heading-compliance">
        <h2 id="heading-compliance">Compliance Status</h2>
        <p>
          This website is <strong>totally compliant</strong> with the requirements set out in Annex A
          of the UNI EN 301549:2018 standard (WCAG 2.2) and the requirements of Annex A of the
          Ministerial Decree of July 5, 2005 (WCAG 2.0).
        </p>
        </section>

        <section aria-labelledby="heading-drafting">
        <h2 id="heading-drafting">Drafting of the Accessibility Declaration</h2>
        <p>
          This declaration was drafted on <time datetime="2026-03-17">03/17/2026</time>, and updated
          on <time datetime="2026-05-22">05/22/2026</time>, based on evaluations and assessments
          conducted by third parties.
        </p>
        </section>

        <section aria-labelledby="heading-contact">
        <h2 id="heading-contact">Feedback and Contact Information</h2>
        <p>
          Individuals who need assistive technologies or special configurations for navigating content
          can request assistance regarding accessibility and provide feedback at the email address
          <a href="mailto:insurancedigitalhub-support@deloitte.it">insurancedigitalhub-support&#64;deloitte.it</a>.
        </p>
        <p>Please include the following information in the email, along with your feedback:</p>
        <ul>
          <li>URL of the site, page, or document and explanation of the issue</li>
          <li>
            Equipment details (operating system, browser, and any assistive tools or technologies
            used)
          </li>
        </ul>
        <p>
          Responses to questions and feedback will be provided within 30 days of receipt. Any reports
          outside the scope of accessibility cannot be addressed.
        </p>
        <p>Personal data will be processed in accordance with the privacy policy.</p>
        </section>

        <section aria-labelledby="heading-agid-en">
        <h2 id="heading-agid-en">How to Submit Reports to AgID</h2>
        <p>
          In case of an unsatisfactory response or no response within thirty days to a notification
          or request, the individual can submit a report using the method indicated on the official
          AgID website.
        </p>
        </section>

        <section aria-labelledby="heading-website-info">
        <h2 id="heading-website-info">Website Information</h2>
        <dl>
          <dt>Date of website publication</dt>
          <dd><time datetime="2026-05-31">31/05/2026</time></dd>

          <dt>Usability tests conducted?</dt>
          <dd>Yes</dd>

          <dt>CMS used for the website</dt>
          <dd>No CMS (Custom Web-Application)</dd>
        </dl>
        </section>

        <section aria-labelledby="heading-org-info">
        <h2 id="heading-org-info">Organization Information</h2>
        <dl>
          <dt>Number of employees with disabilities in the administration</dt>
          <dd>0</dd>

          <dt>Number of workstations for employees with disabilities</dt>
          <dd>0</dd>
        </dl>
        </section>

      </article>
    }

    <div class="back-link">
      <button
        pButton
        type="button"
        [label]="returnButtonLabel()"
        severity="secondary"
        [outlined]="true"
        (click)="goHome()"
      ></button>
    </div>
  </div>
</div>
